import { DataTable } from "@msuite/ui/table";
import { useContactBankAccounts } from "@/hooks/use-contact-bank-accounts";
import { ContactBankAccountsMenu } from "./contact-bank-accounts-menu";
import { columns } from "./table-config";

/** Props Interface */
interface ContactBankAccountsProps {
	contactId: string;
}

/** The accounts the contact is paid on, the default first. */
export function ContactBankAccounts({ contactId }: ContactBankAccountsProps) {
	/** Query */
	const { bankAccounts, isLoading, queryKey, refetch } = useContactBankAccounts(contactId);

	/** Render */
	return (
		<DataTable
			data={bankAccounts}
			columns={columns}
			persistenceKey="contact-bank-accounts-table"
			isLoading={isLoading}
			queryKey={queryKey}
			refetch={refetch}
			menu={<ContactBankAccountsMenu contactId={contactId} />}
		/>
	);
}
